import { render, staticRenderFns } from "./ProItemList.vue?vue&type=template&id=086316e6"
import script from "./ProItemList.vue?vue&type=script&lang=ts"
export * from "./ProItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports